import TopBar from "components/Layout/TopBar";
import React, {useEffect, useState} from "react";
import {useAlert} from "react-alert";
import {useNavigate} from "react-router";
import {ClipLoader} from 'react-spinners';
import useAuthz from "../../hooks/useAuthz";
import MyForm from '../../components/Layout/MyForm';
import MyButton from "../../components/Layout/MyButton";
import { faCheck, faXmark } from '@fortawesome/free-solid-svg-icons';
import axios from "axios";
import {URL_API} from "../../utils/globalConfig";
import {logError} from "../../components/Utils/FormatData";

const style = {
	container: {height: 'calc(100% - 50px)'},
	formContainer: {width: '50%', margin: '20px'},
	formContent: {flexDirection: 'row'},
	rowActions: {width: '100%', margin: '20px', height: 'auto'},
	inputForm: {width: '90%', margin: '20px'}
}

const formElementPatrimoine = [
	{id: 'id_oa', name: 'id_oa', label: 'id_oa', type: 'text', required: true, readOnly: false, style: style.inputForm},
	{id: 'id_oa_anc', name: 'id_oa_anc', label: 'id_oa_anc', type: 'text', required: false, readOnly: false, style: style.inputForm},

	{id: 'axis', name: 'axis', label: 'AXE', type: 'text', required: true, readOnly: false, style: style.inputForm},
	{id: 'linkedAxis', name: 'linkedAxis', label: 'AXE DE RATTACHEMENT', type: 'text', required: true, readOnly: false, style: style.inputForm},
	{id: 'type', name: 'type', label: 'TYPE', type: 'text', required: true, readOnly: false, style: style.inputForm},

	{id: 'direction', name: 'direction', label: 'SENS', type: 'text', required: true, readOnly: false, style: style.inputForm},
	{id: 'dtPose', name: 'dtPose', label: 'DATE POSE', type: 'date', required: false, readOnly: false, style: style.inputForm},
	{id: 'info', name: 'info', label: 'INFO ÉLÉMENT PATRIMOINE', type: 'text', required: false, readOnly: false, style: style.inputForm},
	{id: 'description', name: 'description', label: 'ÉCHANGEUR', type: 'text', required: false, readOnly: false, style: style.inputForm},
	{id: 'landmark', name: 'landmark', label: 'PR', type: 'text', required: true, readOnly: false, style: style.inputForm},

	{id: 'latitude', name: 'latitude', label: 'LATITUDE', type: 'text', required: false, readOnly: false, style: style.inputForm},
	{id: 'longitude', name: 'longitude', label: 'LONGITUDE', type: 'text', required: false, readOnly: false, style: style.inputForm},
	{id: 'network', name: 'network', label: 'RÉSEAU', type: 'text', required: false, readOnly: false, style: style.inputForm},
	{id: 'region', name: 'region', label: 'RÉGION', type: 'text', required: false, readOnly: false, style: style.inputForm},
	{id: 'center', name: 'center', label: 'CENTRE', type: 'text', required: false, readOnly: false, style: style.inputForm},

	{id: 'ppaUnit', name: 'ppaUnit', label: 'PPA UNIT', type: 'text', required: false, readOnly: false, style: style.inputForm},
	{id: 'length', name: 'length', label: 'LONGUEUR (en mm)', type: 'text', required: false, readOnly: false, style: style.inputForm},
	{id: 'width', name: 'width', label: 'LARGEUR (en mm)', type: 'text', required: false, readOnly: false, style: style.inputForm},
	{id: 'height', name: 'height', label: 'HAUTEUR (en mm)', type: 'text', required: false, readOnly: false, style: style.inputForm},

	{id: 'weight', name: 'weight', label: 'POIDS MAX (en kg)', type: 'text', required: false, readOnly: false, style: style.inputForm},
	{id: 'airPulling', name: 'airPulling', label: 'TIRANT D\'AIR', type: 'text', required: false, readOnly: false, style: style.inputForm},
];

const CreateOrEditElementsPatrimoines = (props) => {
	const element_id = new URLSearchParams(location.search).get("id")
	const [isLoading, setIsLoading] = useState(true);
	const [elementPatrimoine, setElementPatrimoine] = useState({
		id: 0,
		id_oa: null,
		id_oa_anc: null,

		axis: null,
		linkedAxis: null,
		type: null,

		direction: null,
		dtPose: null,

		info: null,
		description: null,
		landmark: null,

		latitude: null,
		longitude: null,

		network: null,
		region: null,
		center: null,

		manager: null,
		ppaUnit: null,

		length: null,
		width: null,
		height: null,
		weight: null,
		airPulling: null,
		deleted: false,
	});
	const routeElementsPatrimoines = "/panneau-administration/elements-patrimoines";
	const [authz, user, profil] = useAuthz();
	const navigate = useNavigate();
	const alert = useAlert();

	//#region useEffect

	useEffect(() => {
		if (profil.profil === 1) {
			if (element_id) {
				document.title = "TE - Edition d'un élément patrimoine";
				loadExistingElementPatrimoine();
			} else {
				document.title = "TE - Création d'un élément patrimoine";
			}
			setIsLoading(false);
		} else {
			alert.error("Vous n'êtes pas autorisé à accéder à ce module");
			navigate(routeElementsPatrimoines);
		}
	}, []);

	//#endregion

	//#region Fonctions

	const handleValid = () => {
		if (elementPatrimoine.id_oa === null || elementPatrimoine.id_oa === '') {
			alert.error('L\'identifiant OA est obligatoire');
			return;
		}

		if (elementPatrimoine.axis === null || elementPatrimoine.axis === '') {
			alert.error('L\'axe est obligatoire');
			return;
		}

		if (elementPatrimoine.linkedAxis === null || elementPatrimoine.linkedAxis === '') {
			alert.error('L\'axe de rattachement est obligatoire');
			return;
		}

		if (elementPatrimoine.type === null || elementPatrimoine.type === '') {
			alert.error('Le type est obligatoire');
			return;
		}

		if (elementPatrimoine.direction === null || elementPatrimoine.direction === '') {
			alert.error('Le sens est obligatoire');
			return;
		}

		if (elementPatrimoine.landmark === null || elementPatrimoine.landmark === '') {
			alert.error('Le PR est obligatoire');
			return;
		}


		createOrEditElementPatrimoine();
	};
	const handleChangeValue = (event) => {
		if (event?.target) {
			setElementPatrimoine({...elementPatrimoine, [event.target.name]: event.target.value});
		} else {
			setElementPatrimoine({...elementPatrimoine, dtPose: event});
		}
	};

	//#endregion

	// region API

	const loadExistingElementPatrimoine = () => {
		axios({method: 'get', url: `${URL_API}/element-patrimoine/get-heritage-element?id=${element_id}`})
			.then((response) => {
				setElementPatrimoine(response.data);
				setIsLoading(false);
			})
			.catch((error) => {
				logError(alert, error);
			});
	}
	const createOrEditElementPatrimoine = () => {
		axios({method: 'post', url: `${URL_API}/element-patrimoine/create-or-edit`, data: elementPatrimoine, params: {userAction: user.user_id}})
			.then(() => {
				alert.removeAll();
				if (elementPatrimoine.id !== null) {
					alert.success(`L'élément patrimoine a été édité avec succés`);
				} else {
					alert.success(`L'élément patrimoine a été créé avec succés`);
				}
				navigate(routeElementsPatrimoines);
			})
			.catch((error) => {
				logError(alert, error);
			});
	}

	//#endregion

	return (<div style={{height: '100%'}}>
		<TopBar title={element_id ? 'Editer un élément patrimoine' : 'Créer un élément patrimoine'} className='topbar-contenu' color={props.params.color}
						buttons={null}/>

		<div className='row' style={{...style.container, alignItems: isLoading ? 'center' : '', overflow: 'auto'}}>
			<ClipLoader color='#0094ca' loading={isLoading} size={75} css={'display: flex; margin: 25px;justify-content: center;'}/>

			{!isLoading &&
				(
					<>
						<div className='form-content-center' style={style.formContent}>
							<div style={style.formContainer}>
								<MyForm data={elementPatrimoine} variant={'outlined'} setData={setElementPatrimoine} form={formElementPatrimoine} onChange={handleChangeValue}/>
							</div>
						</div>

						<div className='row' style={style.rowActions}>
							<MyButton onClick={() => navigate(routeElementsPatrimoines)} style={'buttonDefault'} label={'Annuler'} icon={faXmark}/>
							<MyButton onClick={handleValid} style={'buttonValidation'} label={'Valider'} icon={faCheck}/>
						</div>
					</>
				)
			}
		</div>
	</div>);
}

export default CreateOrEditElementsPatrimoines;
